export default uiMaskRun

/** @ngInject */
function uiMaskRun(uiMaskConfig) {
    uiMaskConfig.clearOnBlur = false

  // Fix input bug on android device
  // https://github.com/angular-ui/ui-mask/pull/26
    const isAndroid = /(android)/i.test(navigator.userAgent)
    if (isAndroid) {
        const index = uiMaskConfig.eventsToHandle.indexOf('input')
        return uiMaskConfig.eventsToHandle.splice(index, 1)
    }
}



// WEBPACK FOOTER //
// ./src/config/ui-mask.js